// extracted by mini-css-extract-plugin
export var chevronIcon = "_4m-2";
export var teamName = "_4m-1";
export var teamSwitcherButton = "_4m-0";